module.exports = "<ng-select \n    [searchable]=\"false\" \n    [clearable]=\"false\"\n    [multiple]=\"true\"\n    [(ngModel)]=\"selectedValuesModel\"\n    (change)=\"onChangeSelect()\"\n    *ngIf=\"listValues && listValues.length\">\n        <ng-option \n            *ngFor=\"let value of listValues\" \n            value=\"{{value.code}}\">\n            {{value.name}}\n        </ng-option>\n</ng-select>"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/components/bitmask-field/bitmask-field.component.html
// module id = ./src/app/view/components/bitmask-field/bitmask-field.component.html
// module chunks = main